module.exports = __webpack_public_path__ + "img/changying_md.5ddb5f81.png";